import React from 'react';
import Spinner from '../../../moduleComponents/SpinnerLoad';

const CardBudgetDetailed = ({ budgets = [], loading = false, error = null }) => {
  if (loading) {
    return (
      <div className="w-full mt-2 flex justify-center py-12">
        <Spinner />
      </div>
    );
  }

  if (error) {
    return (
      <div className="w-full mt-2 p-4 bg-red-50 border border-red-200 text-red-700 rounded-xl">
        {error}
      </div>
    );
  }

  return (
    <div className="w-full mt-2">
      <div className="bg-white shadow rounded-xl overflow-hidden">
        <div className="bg-gray-600 px-4 py-2">
          <h2 className="text-lg font-semibold text-white">Budget — Detailed</h2>
          <span className="text-xs text-white opacity-70">({budgets.length} entries)</span>
        </div>
        <div className="overflow-auto max-h-[60vh]">
          {budgets.length === 0 ? (
            <div className="p-6 text-center text-gray-500 text-sm">No budgets recorded.</div>
          ) : (
            <table className="w-full min-w-[600px] text-sm">
              <thead>
                <tr className="bg-gray-50 border-b border-gray-200">
                  <th className="text-left py-2 px-3 font-medium text-gray-600">date</th>
                  <th className="text-left py-2 px-3 font-medium text-gray-600">class_l0</th>
                  <th className="text-left py-2 px-3 font-medium text-gray-600">class_l1</th>
                  <th className="text-left py-2 px-3 font-medium text-gray-600">class_l2</th>
                  <th className="text-left py-2 px-3 font-medium text-gray-600">type</th>
                  <th className="text-right py-2 px-3 font-medium text-gray-600">std_amount</th>
                </tr>
              </thead>
              <tbody>
                {budgets.map((row) => (
                  <tr key={row.id} className="border-b border-gray-100 hover:bg-gray-50">
                    <td className="py-1.5 px-3 text-gray-700">{(row.plan_date || '').slice(0, 10)}</td>
                    <td className="py-1.5 px-3 text-gray-800">{row.class_l0 ?? '—'}</td>
                    <td className="py-1.5 px-3 text-gray-700">{row.class_l1 ?? '—'}</td>
                    <td className="py-1.5 px-3 text-gray-700">{row.class_l2 ?? '—'}</td>
                    <td className="py-1.5 px-3 text-gray-600">{row.budget_type ?? '—'}</td>
                    <td className="py-1.5 px-3 text-right font-mono tabular-nums">
                      {row.std_amount != null ? Number(row.std_amount).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '—'}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default CardBudgetDetailed;
